module.exports = __webpack_public_path__ + "assets/img/useravatar.32ea34d2.jpg";